import { getRng } from './utils/random';

export const generatePyramid = (levels = 4, difficulty = 'medium', seed = null) => {
  const rng = getRng(seed);
  const pyramid = [];

  // 1. إنشاء القاعدة (السطر الأخير) بأرقام عشوائية
  const baseLength = levels;
  const baseRow = [];
  const maxBaseNum = difficulty === 'easy' ? 10 : difficulty === 'medium' ? 20 : 50;

  for (let i = 0; i < baseLength; i++) {
    baseRow.push(Math.floor(rng() * maxBaseNum) + 1);
  }
  pyramid.push(baseRow);

  // 2. بناء الهرم من تحت لفوق (حساب المجموع)
  for (let i = 0; i < levels - 1; i++) {
    const prevRow = pyramid[pyramid.length - 1]; // السطر اللي تحت
    const newRow = [];
    for (let j = 0; j < prevRow.length - 1; j++) {
      newRow.push(prevRow[j] + prevRow[j+1]); // الجمع
    }
    pyramid.push(newRow);
  }

  // الهرم دابا كيكون مقلوب فالمصفوفة (base index 0)، خاصنا نقلبوه باش يجي الراس لفوق
  const fullSolution = [...pyramid].reverse();

  // 3. صنع اللغز (إخفاء بعض الأرقام)
  const puzzle = fullSolution.map(row => row.map(val => {
     // Easy: نخبيو 40%، Medium: 50%، Hard: 60%
     const chance = difficulty === 'easy' ? 0.4 : difficulty === 'medium' ? 0.5 : 0.6;
     return rng() < chance ? null : val; // null يعني خانة خاوية
  }));

  // تأكد أن الراس (Top) ديما خاوي باش يحسبوه (اختياري)
  // puzzle[0][0] = null; 

  return { solution: fullSolution, puzzle: puzzle };
};